import PlayableTrack from "./PlayableTrack";
import { getSegueInfo } from "./trackUtils";

export default function TrackItem({
  track,
  nextTrack,
  isPlaying,
  tooltipState,
  onTrackClick,
  onTrackHover,
}) {
  const trackId = track.track_id;
  const isTooltipActive =
    tooltipState.visible && tooltipState.trackId === trackId;
  const segueInfo = getSegueInfo(track, nextTrack);

  const handleMouseEnter = (e) => {
    trackId && onTrackHover(trackId, track.origin, e, true);
  };

  const handleMouseLeave = (e) => {
    trackId && onTrackHover(trackId, track.origin, e, false);
  };

  const handleInfoClick = (e) => {
    onTrackHover(trackId, track.origin, e, true, true);
  };

  return (
    <li
      className={`track-item ${isPlaying ? "active" : ""}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {track.mp3_url ? (
        <PlayableTrack
          track={track}
          trackId={trackId}
          isPlaying={isPlaying}
          isTooltipActive={isTooltipActive}
          onTrackClick={onTrackClick}
          onInfoClick={handleInfoClick}
          segueInfo={segueInfo}
        />
      ) : (
        <span className="track-title">{track.title}</span>
      )}
    </li>
  );
}
